import { toast } from "react-toastify";

export const notify = (message, type = "default") => {
  toast(message, { type: type });
};
